'use client';

import { Stack, Text, Button, Paper } from '@mantine/core';
import { IconArrowRight, IconPlayerSkipForward } from '@tabler/icons-react';
import LinkedInConnect from '@/components/mentorshipApplication/LinkedInConnect';

interface LinkedInStepProps {
  mentorId?: string;
  mentorHandle?: string;
  onNext: () => void;
  onSkip: () => void;
  linkedinUrl?: string;
  onLinkedInConnected: (url: string) => void;
  onBeforeRedirect?: () => Promise<void>;
}

export default function LinkedInStep({
  mentorId,
  mentorHandle,
  onNext,
  onSkip,
  linkedinUrl,
  onLinkedInConnected,
  onBeforeRedirect
}: LinkedInStepProps) {
  const handleLinkedInConnected = (url: string) => {
    onLinkedInConnected(url);
    // Auto-advance to next step after successful connection
    setTimeout(() => {
      onNext();
    }, 1500); // Small delay to show success state
  };

  return (
    <Paper p="xl" radius="md" withBorder>
      <Stack gap="lg">
        <div>
          <Text size="xl" fw={600} mb="xs">
            Connect Your LinkedIn Profile
          </Text>
          <Text size="sm" c="dimmed">
            Adding your LinkedIn profile helps mentees learn more about your professional background and builds trust. This step is optional but highly recommended.
          </Text>
        </div>

        <LinkedInConnect
          mentorId={mentorId}
          mentorHandle={mentorHandle}
          context="mentorship"
          onLinkedInConnected={handleLinkedInConnected}
          linkedinUrl={linkedinUrl}
          onBeforeRedirect={onBeforeRedirect}
        />

        {!linkedinUrl && (
          <Stack gap="sm">
            <Button
              variant="subtle"
              leftSection={<IconPlayerSkipForward size={16} />}
              onClick={onSkip}
              size="md"
              fullWidth
            >
              Skip for now
            </Button>
            <Text size="xs" c="dimmed" ta="center">
              You can always connect your LinkedIn profile later from your account settings
            </Text>
          </Stack>
        )}

        {linkedinUrl && (
          <Button
            leftSection={<IconArrowRight size={16} />}
            onClick={onNext}
            size="md"
            fullWidth
          >
            Continue to Payment
          </Button>
        )}
      </Stack>
    </Paper>
  );
}
